module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="throttle"><span class="lockout"></span><span class="retry-after"></span></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/ThrottleView.tpl
// module id = 2791
// module chunks = 0